import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { Grid, FormControlLabel, Radio, DialogActions } from "@material-ui/core";
import { connect } from "react-redux";
import { MenuItem, InputLabel } from "@material-ui/core";
import { StyledFormControl, StyledSelect, StyledTooltip, StyledRadioGroup, TopRadioWrapper, ConfigurationFormLabel } from "../FuiStyles";
import { longTextEndDate } from "../Constants/LongText";
import { DateTextFieldCommonComponent, DateTextFieldCommonComponentv2 } from "../DateTextFieldCommonComponent/DateTextFieldCommonComponent";
import { checkWBSECode, checkBenefitsExpected, checkPOCname, createMaxDate } from "./CommonFunctions";
import GeneralForm from "./GeneralForm";
import * as FormField from "./IndividualFormFields";
import * as PlatformFormField from "./IndividualFormFields";
import * as fuiRedux from "../../../redux/fui/index";
import { CommonDialogV2 } from "../../common/CommonComponents/Dialog";
import { fetchExternalClientDetails, checkIsWBSEValid } from "../../../redux/fui/index";
import { AcceptButton2 } from "../../common/CommonComponents/Buttons";
import ValidationDialog from './ValidationDialog';
import useFormValidationWithBorders from "./useFormValidationWithBorders";
/**
 * On premise Service Form Form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */
const OnPremiseService = ({
  history, // get route history
  values, // the value would be changed by user's input
  updateOPSForm, //the function to update OPSForm values which is from redux
  selectedEnvironment,
  getSelectedEnvironment,
  configurationType,
  minDate,
  maxDate,
  getServiceEndDate,
  isServiceEndDateInvalid,
  createdBy,
  setIsAllValid,
  isExternalClientLoading,
  externalClientData,
  externalClientError,
  fetchExternalClientDetails,
  dailyDataVolumeData,
  getNotesValue,
  notesValidations,
  formClickSubmit,
  isLoading,
  checkIsWBSEValid,
  isWBSEValid, // this value shows whether the WBSE is valid or not from redux
}) => {

  const config = configurationType === "quick";
  // check whether values are valid
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);

  // check whether WBSECode is equal to MD & I WBSE
  const [isWBSECodeMDIValid, setIsWBSECodeMDIValid] = useState(true);
  const [isProjectNameValid, setIsProjectNameValid] = useState(true);
  const [isDailyDataVolumeValid, setIsDailyDataVolumeValid] = useState(true);
  const [isBenefitsExpectedValid, setIsBenefitsExpectedValid] = useState(true);
  const [isInfrastructureType, setIsInfrastructureType] = useState(true);
  const [selectedAsset, setSelectedAsset] = useState([]);
  const [selectedDataVolumeSizes, setSelectedDataVolumeSizes] = useState([]);
  const [totalSelectedDailyDataVolume, setTotalSelectedDailyDataVolume] = useState(0);
  const [isNoteVisible, setNoteVisible] = useState(true);

  const dailyDataVolumes = localStorage.getItem("dailyDataVolumes")
  const dailyDataVolumesSplit = dailyDataVolumes.split(",")
  const dailyDataVolumesList = [];
  dailyDataVolumesSplit.forEach(ele => dailyDataVolumesList.push(+ele))
  const dataVolumesSort = dailyDataVolumesList.sort((a, b) => a - b);
  const dataVolumes = dataVolumesSort.filter(item => {
    return (typeof item === "number") && item <= 120;
  });
  // Enhanced validation with borders and dialog
  const { validationErrors, showValidationDialog, closeDialog, handleValidationResult } = useFormValidationWithBorders(values, isWBSEValid, selectedEnvironment);
  const assets = "AiOps Automation for Splunk Cluster,Automatic Ticket Resolver,Automatic Ticket Resolver CaaS,Automation Journey,Automation Planner,ChatBot,Cloud Chargeback,CloudChaser,Cloud Security and Compliance Checker,Mainframe 360,myWizard AiOps Automatic Ticket Assignment (ATA),myWizard AiOps Batch,myWizard AiOps RPA,Report Extractor,Salesforce 360,Service Integrator,Smart Alerts,Smart Capacity Prediction,StormWatch,Ticket Analysis Application,Turing,myBuddy,DevOps Analytics,Splunk Watch,Estimator,Cloud Asset Management (CAM),Oracle360,Codeless Automation Accelerator (CAF),Stormseer,Supply Chain Control Tower,Cisco-EOX,Automation Platform Monitoring (AuPM),EventOps,Security and Operations Governance RDD (SOG_RDD),Security and Operations Governance Brand Risk (SOG_Brandrisk),Intelligent Opportunity Miner - IOM,Virtual Data Scientist - VDS,AI Core (ingrAIn),myWizard AIOps BPM Salesforce,Embedded RPA Suites,myWizard AiOps for SAP,Stack Monitoring Suite,myWizard AiOps Appstore,HR Buddy"
  const assetsList = assets.split(",");
  const sortAssetsList = assetsList.sort();
  const [isTeamNameSelected, setIsTeamNameSelected] = useState(true);
  const [env, setEnv] = useState("");

  const [sapContractCodeLength, setSapContractCodeLength] = useState("0");
  const [isPocvalid, setPocvalid] = useState(true);
  const [isPlanInputValid, setIsPlanInputValid] = useState(false);
  const [isChecked, setIsChecked] = useState(true);
  const handleContractAvailabilityChange = (event) => {
    const value = event.target.value;
    setIsChecked(value === "yes");
    // updateOPSForm("IsContractIdAvailable", value);
    if (value === "no") {
      updateOPSForm("IsContractIdAvailable", "no");
      updateOPSForm("SAPContractID", "0000000000");
      updateOPSForm("EndToEndUId", "");
      updateOPSForm("ContractAvailabilityDate", createMaxDate(14));
      setSapContractCodeLength(10);
      setPocvalid(false);
    } else {
      setPocvalid(true);
      updateOPSForm("SAPContractID", "");
      // updateOPSForm("ClientName", "");
      updateOPSForm("EndToEndUId", "");
      setSapContractCodeLength(0);
    }
  };

  useEffect(() => {
    if (config) {
      //updateOPSForm("ClientName", "")
      updateOPSForm("EndToEndUId", "")
      updateOPSForm("Company", "")
      updateOPSForm("AvanadeCountry", "")
      updateOPSForm("AccentureCountry", "")
      updateOPSForm("ContractAvailabilityDate", "")
    }
  }, [config]);

  if (!config) {
    if (externalClientData.length > 0) {
      updateOPSForm("ClientName", externalClientData[0])
      updateOPSForm("EndToEndUId", externalClientData[1])
      if (externalClientData[2] !== undefined)
        updateOPSForm("Company", externalClientData[2])
      if (externalClientData[3] !== undefined)
        updateOPSForm("AvanadeCountry", externalClientData[3])
      if (externalClientData[4] !== undefined)
        updateOPSForm("AccentureCountry", externalClientData[4])
      updateOPSForm("ContractAvailabilityDate", "")
      updateOPSForm("RITM", "N/A");
      updateOPSForm("IsContractIdAvailable", "yes")
    }
  }

  if (!config) {
    (isBenefitsExpectedValid) &&
      !isServiceEndDateInvalid && sapContractCodeLength == 10 && !externalClientError && isWBSEValid && isWBSECodeMDIValid && isInfrastructureType && isProjectNameValid && isTeamNameSelected && isDailyDataVolumeValid && isPocvalid
      ? setIsAllValid(true)
      : setIsAllValid(false);
  } else { //internal user
    (isBenefitsExpectedValid) &&
      !isServiceEndDateInvalid && isWBSEValid && isWBSECodeMDIValid && isInfrastructureType && isProjectNameValid && isTeamNameSelected && isDailyDataVolumeValid
      ? setIsAllValid(true)
      : setIsAllValid(false);
  }

  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";
  updateOPSForm("ConfigurationType", configurationType);

  // get user's input
  const handleChange = (event, fieldName) => {
    if (fieldName === "TentativeServiceEndDate") {
      updateOPSForm(fieldName, event);
      getServiceEndDate(event);
    } else if (fieldName === "TeamName") {
      if (event !== undefined || event !== null) {
        updateOPSForm(fieldName, event);
        setIsTeamNameSelected(true);
        if (values.TeamName !== "Others") {
          updateOPSForm("TeamNameOthers", "")
        }
      } else {
        setIsTeamNameSelected(false);
      }
    } else {
      const value = event.target.value;
      event.preventDefault();
      updateOPSForm(fieldName, value);

      if (fieldName === "WBSEcode") {
        const wbsevalue = value.toUpperCase()
        if (wbsevalue.trim() === "CBYDQ001") {
          setIsWBSECodeMDIValid(false)
        }
        // setIsWBSECodeValid(checkWBSECode(value));
        const isWBSEFormatValid = checkWBSECode(value);
        if (isWBSEFormatValid) {
          checkIsWBSEValid(value)
        }
      }
      if (fieldName === "Pocdetails") {
        setPocvalid(checkPOCname(value));
      }
      if (fieldName === "ProjectName") {
        if (value.length > 32 || value.length < 3) {
          setIsProjectNameValid(false)
        } else {
          setIsProjectNameValid(true)
        }
      }
      if (fieldName === "InfrastructureType") {
        if (value == "") {
          setIsInfrastructureType(false);
        } else {
          setIsInfrastructureType(true);
        }
      }
      if (fieldName === "RequestNotes") {
        if (value.length > 0 && value.length < 247) {
          getNotesValue({ emptyString: false, maxLength: false });
        } else if (value.length === 0) {
          getNotesValue({ emptyString: true, maxLength: false });
        } else if (value.length > 246) {
          getNotesValue({ emptyString: false, maxLength: true });
        }
      }

      if (fieldName === "BenefitsExpected") {
        if (value[0] === "0") {
          setIsBenefitsExpectedValid(false);
        } else {
          setIsBenefitsExpectedValid(checkBenefitsExpected(value));
        }
      }
      if (fieldName === "TentativeServiceEndDate") {
        getServiceEndDate(value);
      }
      if (fieldName === "SAPContractID") {
        let sapLength = value.length
        setSapContractCodeLength(sapLength)
        if (sapLength == 10) {
          fetchExternalClientDetails(value)
        }
      }
      if (externalClientData) {
        updateOPSForm("ClientName", externalClientData[0])
        updateOPSForm("EndToEndUId", externalClientData[1])
        if (externalClientData[2] !== undefined)
          updateOPSForm("Company", externalClientData[2])
        if (externalClientData[3] !== undefined)
          updateOPSForm("AvanadeCountry", externalClientData[3])
        if (externalClientData[4] !== undefined)
          updateOPSForm("AccentureCountry", externalClientData[4])
      }
      if (fieldName === "AiOpsAsset") {
        setSelectedAsset(value)
      }
      if (fieldName === "DailyDataVolume") {
        var total = 0;
        for (var i in value) {
          total += value[i];
        }
        setTotalSelectedDailyDataVolume(total)
        setSelectedDataVolumeSizes(value)
        updateOPSForm("SplitDataVolume", value);
        updateOPSForm("DailyDataVolume", total);
        if (total > 0 && total < 150) {
          setIsDailyDataVolumeValid(true)
        } else {
          setIsDailyDataVolumeValid(false)
        }
      }

      if (value === "AiOps Asset") {
        updateOPSForm("Custom", "")
      }

      if (value === "Custom") {
        setSelectedAsset([])
        updateOPSForm("AiOpsAsset", [])
      }
      if (fieldName === "GDPR" && value === "yes") {
        updateOPSForm("DeploymentRegion", "");
      }
      if (fieldName === "DataClassification") {
        if (value === "Client-Production" || value === "Internal-Production") {
          setEnv("Production")
        } else if (value === "Client-NonProduction") {
          setEnv("Test")
          updateOPSForm("Tier", "")
        } else if (value === "AppTeam-Development") {
          setEnv("Dev")
          updateOPSForm("Tier", "")
        } else if (value === "AppTeam-Testing") {
          setEnv("Test")
          updateOPSForm("Tier", "")
        } else {
          setEnv("")
          updateOPSForm("Tier", "")
        }
      }

    }
  };

  const handleChangeMobileNo = (event, fieldName) => {
    const re = /^[0-9]{0,}$/;
    const value = event.target.value;
    re.test(value) && updateOPSForm(fieldName, value);
  };
  getSelectedEnvironment(env);
  updateOPSForm("Environment", env);

  //form validation
  const validateInputFields = (step) => {
    // Only validate on final submit (step 2) or when explicitly called with 'submit'
    if (step !== 'step2' && step !== 'submit') {
      return true; // Skip validation for intermediate steps
    }

    let ispass = true;
    const missingFields = [];

    // Collect all required fields for final validation
    let allRequiredFields = [
      'ProjectName',
      'WBSEcode',
      'SecondaryPOC',
      'DataClassification',
      'TeamName',
      'RequestNotes',
      'InfrastructureType',
      'LicensePurpose',
      'DeploymentRegion',
      'DailyDataVolume',
      'Environment',
      'TentativeServiceEndDate'
    ];

    // Add conditional fields based on configuration
    if (!config) {
      if (isChecked) {
        allRequiredFields.push('SAPContractID');
      } else {
        allRequiredFields.push('Pocdetails', 'ClientName');
      }
    }

    // Add license purpose specific fields
    if (values.LicensePurpose === "AiOps Asset") {
      allRequiredFields.push('AiOpsAsset');
    }
    if (values.LicensePurpose === "Custom") {
      allRequiredFields.push('Custom');
    }

    // Check each required field
    for (const fieldname of allRequiredFields) {
      let isFieldInvalid = false;

      if (fieldname === "WBSEcode" && (!values[fieldname] || values[fieldname] === "" || !isWBSEValid)) {
        isFieldInvalid = true;
        missingFields.push(`${fieldname} (${!isWBSEValid ? 'Invalid WBSE code' : 'Required'})`);
      } else if (fieldname === "TentativeServiceEndDate" && (!selectedEnvironment || selectedEnvironment === "")) {
        // TentativeServiceEndDate requires environment to be selected first
        isFieldInvalid = true;
        missingFields.push(fieldname);
      } else if (fieldname === "Pocdetails") {
        if (values['Pocdetails'] === "" || !isPocvalid && values['Pocdetails'] !== "") {
          missingFields.push(fieldname);
          ispass = false;
        }
      } else if (!values[fieldname] || values[fieldname] === "" || (fieldname === 'AiOpsAsset' && values[fieldname].length === 0)) {
        isFieldInvalid = true;
        missingFields.push(fieldname);
      }

      if (isFieldInvalid) {
        ispass = false;
      }
    }
    // Use the new validation handler
    handleValidationResult(ispass, missingFields, formClickSubmit);
    return ispass;
  }

  return (
    <>
      <GeneralForm
        isPlanInputValid={isPlanInputValid}
        FormId={11}
        validateInputFields={validateInputFields}
        ClientContractFields={

          <div>
            {!config ?
              <TopRadioWrapper>
                <ConfigurationFormLabel component="legend">
                  Is a Contract ID available?
                </ConfigurationFormLabel>


                <StyledRadioGroup
                  aria-label="contract-available"
                  name="contract-available"
                  value={isChecked ? "yes" : "no"}
                  onChange={handleContractAvailabilityChange}
                  row
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio color="primary" />}
                    label="YES"
                  />
                  <FormControlLabel
                    value="no"
                    control={<Radio color="primary" />}
                    label="NO"
                  />
                </StyledRadioGroup>
              </TopRadioWrapper>
              : ""
            }

            {(!isChecked && !config) &&
              <div style={{ fontSize: "small", color: "#0041F0" }}>
                <em>
                  To proceed with provisioning without a Contract ID, please provide the following mandatory details
                </em>
                <ul>
                  <li>WBSE Code (used for chargeback if contract is not provided)</li>
                  <li>Opportunity ID (for deal tracking and reference)</li>
                  <li>Expected Contract Availability Date (must be within 42 days)</li>
                  <li>Client Point of Contact (name and email for contract follow-up)</li>
                </ul>
              </div>
            }
            < div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >
                {(!config && isChecked) ?
                  <Grid item xs={4}>
                    {PlatformFormField.SAPContractIDPlatformField(values, handleChange, externalClientError, isExternalClientLoading, sapContractCodeLength)}
                  </Grid>
                  : (!config && !isChecked) ?
                    <Grid item xs={4}>
                      {FormField.Pocvalid(handleChange, values, isPocvalid)}
                    </Grid>
                    : <></>
                }
                {(!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError) &&
                  <Grid item xs={4}>
                    {PlatformFormField.ClientNamePlatformField(
                      values,
                      handleChange,
                      externalClientData[0]
                    )}
                  </Grid>
                }
                {!config &&
                  isChecked &&
                  sapContractCodeLength === 10 &&
                  !isExternalClientLoading &&
                  !externalClientError && (
                    <Grid item xs={4}>
                      {PlatformFormField.EndToEndUIdPlatformField(
                        values,
                        handleChange,
                        externalClientData[1]
                      )}
                    </Grid>
                  )
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    <StyledTooltip
                      title={longTextEndDate}
                      placement="left-start"
                      noValidate
                    >
                      <DateTextFieldCommonComponentv2
                        tentativeServiceEndDate={values.ContractAvailabilityDate}
                        minDate={0}
                        maxDate={createMaxDate(27)}
                        handleChange={handleChange}
                        id="ContractAvailabilityDate"
                        label="Contract Availability Date"
                      />
                    </StyledTooltip>
                  </Grid>
                }
                {(!config && !isChecked) &&
                  <Grid item xs={4}>
                    {FormField.ClientNamePlatformInternal(handleChange, values)}
                  </Grid >
                }
                <Grid item xs={4}>
                  {FormField.ProjectNameField(handleChange, values, isProjectNameValid)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.WBSECodeField(handleChange, values, isWBSECodeValid, isWBSECodeMDIValid, isWBSEValid, isLoading)}
                </Grid >
                <Grid item xs={4}>
                  {FormField.DataClassificationField(handleChange, values, configurationType)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.SecondaryContactonpremise(handleChange, values, config)}
                </Grid>
                <Grid item xs={4}>
                  {FormField.TeamNamesField(handleChange, values, isTeamNameSelected)}
                </Grid >
                {values.TeamName === "Others" &&
                  <Grid item xs={4}>
                    {FormField.TeamNameOthers(handleChange, values)}
                  </Grid >
                }
                {
                  (config &&
                    <Grid item xs={4}>
                      {FormField.ClientNamePlatformInternal(handleChange, values)}
                    </Grid>
                  )
                }
                <Grid item xs={6}>
                  {FormField.InfrastructureTypeField(handleChange, values)}
                </Grid>
                <Grid item xs={6}>
                  {FormField.LicensePurposeField(handleChange, values)}
                </Grid>
                {values.LicensePurpose === "AiOps Asset" &&
                  <Grid item xs={6}>
                    {FormField.AiOpsAssetField(handleChange, values, sortAssetsList, selectedAsset)}
                  </Grid>}
                {values.LicensePurpose === "Custom" &&
                  <Grid item xs={6}>
                    {FormField.CustomField(handleChange, values)}
                  </Grid>
                }
                <Grid item xs={12}>
                  {PlatformFormField.RequestNotesPlatformField(
                    values,
                    handleChange,
                    notesValidations
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        }
        EnvironmentFields={
          <div>
            <div style={{ flexGrow: 1 }}>
              <Grid
                container
                spacing={2}
              >

                <Grid item xs={3}>
                  <StyledFormControl variant="outlined" margin="dense">
                    <InputLabel htmlFor="outlined-Deployment-Region">
                      Deployment Region
                    </InputLabel>
                    <StyledSelect
                      value={values.DeploymentRegion}
                      onChange={(e) => handleChange(e, "DeploymentRegion")}
                      label="Deployment Region"
                      id="DeploymentRegion"
                    >
                      <MenuItem value="">
                        <em>--Select Deployment Region--</em>
                      </MenuItem>
                      <MenuItem value="singapore">Singapore</MenuItem>
                    </StyledSelect>
                  </StyledFormControl>
                </Grid>
                <Grid item xs={6}>
                  {FormField.DailyDataVolumeSplunkLicensePlatformField(handleChange, values, dataVolumes, selectedDataVolumeSizes, totalSelectedDailyDataVolume, isDailyDataVolumeValid)}
                </Grid>
                {/* <Grid item xs={3}> */}
                {/* {PlatformFormField.EnvironmentPlatformField(values, handleChange)} */}
                <Grid item xs={3}>
                  {PlatformFormField.EnvironmentField(values, handleChange, env)}
                </Grid>
              </Grid>
            </div>
          </div>
        }
        ApplicationFields={
          <div style={{ flexGrow: 1 }}>
            <Grid
              container
              spacing={2}
            >
              <Grid item xs={6}>
                <StyledTooltip
                  title={longTextEndDate}
                  placement="left-start"
                  noValidate
                >
                  <DateTextFieldCommonComponent
                    tentativeServiceEndDate={values.TentativeServiceEndDate}
                    selectedEnvironment={selectedEnvironment}
                    isServiceEndDateInvalid={isServiceEndDateInvalid}
                    minDate={minDate}
                    maxDate={maxDate}
                    handleChange={handleChange}
                  />
                </StyledTooltip>
              </Grid>
            </Grid>
          </div>
        }
        history={history}
      ></GeneralForm>
      {!isChecked && (
        <CommonDialogV2
          open={isNoteVisible}
          onClose={() => setNoteVisible(false)}
          title={"Note"}
          textContent={
            <div>
              <div style={{ textAlign: 'center', fontSize: '1.1em', fontWeight: '500' }}>If a valid contract is not provided within the 4-week period</div>
              <ul>
                <li>
                  Provisioned services will be automatically stopped
                </li>
                <li>
                  Cost recovery will be initiated using the provided WBSE code
                </li>
              </ul>
            </div>
          }
          dialogActions={
            <DialogActions>
              <AcceptButton2 onClick={() => setNoteVisible(false)} label={"Ok"} />
            </DialogActions>
          }
        ></CommonDialogV2>
      )}
      <ValidationDialog
        open={showValidationDialog}
        onClose={closeDialog}
        errors={validationErrors}
      />
    </>
  );
};

const MSTP = (state, ownProps) => ({
  email: state.auth.userDetails.email,
  configurationType: state.fui.configurationType,
  values: state.fui.OPSForm,
  externalClientData: state.fui.externalClientData,
  externalClientError: state.fui.externalClientError,
  isExternalClientLoading: state.fui.isExternalClientLoading,
  dailyDataVolumeData: state.home.dailyDataVolumeData,
  isWBSEValid: state.fui.isWBSEValid,
  isLoading: state.fui.isLoading,
});

export default connect(MSTP, {
  updateOPSForm: fuiRedux.updateOPSForm, fetchExternalClientDetails,
  checkIsWBSEValid
})(
  withRouter(OnPremiseService)
);
